import React from 'react'
import { Provider } from 'react-redux'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider'
import createMuiTheme from '@material-ui/core/styles/createMuiTheme'
import ReactDOM from 'react-dom'
import App from './App'
// import NoMatch from "./components/NotFound"
import './index.scss'
import getAttributes from './settings/attributes'
import { actionAppSetUiVersion } from './actions'
import { actions as settingsActions } from './features/Settings'
import validateSteam from './store/steam-validation'
import { Forage } from './store/localforage'
import store from './store'

const theme = createMuiTheme({
    palette: {
        type: 'dark',
    },
})

// Generate the Redux store
export default store

try {
    // Update the document domain to match the location host
    // used to match against the SSO
    const domain = window.location.host
        .split('.')
        .reverse()
        .slice(0, 2)
        .reverse()
        .join('.')

    document.domain = domain
} catch (e) {
    console.info(`Could not set domain: ${e.message}`)
}

try {
    // Validation for STEAM
    // This checks for a STEAM ticket in the query
    // and applies it to the store as necessary
    validateSteam(store)
} catch (error) {
    console.info(`Encountered an error during STEAM startup check: ${error.message}`)
}

try {
    // Populate the redux state based on localforage storage
    new Forage().readIntoState(store)
} catch (error) {
    store.dispatch(settingsActions.markAsLoaded())
    console.info(`Could not update state based on localforage storage on startup: ${error.message}`)
}

// Initialize the UI version of the launcher
try {
    const regex = new RegExp(getAttributes().regex.version, 'i')
    const pathValue = window.location.pathname.match(regex)

    if (pathValue != null) {
        store.dispatch(actionAppSetUiVersion(pathValue[1]))
    }
} catch (error) {
    console.info(`Encountered error while running InitializationMiddleware: ${error.message}`)
}

try {
    ReactDOM.render(
        <Provider store={store}>
            <MuiThemeProvider theme={theme}>
                <Router>
                    <React.Fragment>
                        <Switch>
                            <Route path="/" exact component={App} />
                            <Route component={App} />
                        </Switch>
                    </React.Fragment>
                </Router>
            </MuiThemeProvider>
        </Provider>,
        document.getElementById('root'),
    )
} catch (error) {
    console.info(`Error rendering React dom: ${error.message}`)
}



// WEBPACK FOOTER //
// ./src/index.js